
import React, { Component } from "react";
import Config from "../../../config";
import { tsDateToThaiDate } from "../../../utils/func";
import { Modal, Button ,Select } from 'antd';
import Datetimepicker from "../../jquery/datetimepicker";

const Option = Select.Option;
class Xpage6ef04dc07 extends Component {
  constructor(props) {
    super(props);
    this.state = {modeLayout1 : false ,modeLayout2 : false,modeLayout3 : false ,modeLayout4 : false ,data1:{},data2:{},data3:{},data4:{},visible2:false,visible3:false,visible4:false,m1:{},s:{},
    listTable : [
                    {text:'คณะทำงานด้านการจัดการพลังงาน',},
                    {text:'การประเมินสถานภาพการจัดการพลังงานเบื้องต้น (ในกรณีที่เป็นการนำวิธีการจัดการพลังงานตามกฎกระทรวงฯ มาใช้เป็นครั้งแรก)',},
                    {text:'นโยบายอนุรักษ์พลังงาน',},
                    {text:'การประเมินศักยภาพการอนุรักษ์พลังงาน',},
                    {text:'การกำหนดเป้าหมายและแผนอนุรักษ์พลังงาน และแผนการฝึกอบรม และกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน',},
                    {text:'การดำเนินการตามแผนอนุรักษ์พลังงาน การตรวจสอบและวิเคราะห์การปฏิบัติตามเป้าหมายและแผนอนุรักษ์พลังงาน และแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน',},
                    {text:'การตรวจติดตามและการประเมินการจัดการพลังงาน',},
                    {text:'การทบทวน วิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงาน',},
                ] ,
    AUDIT_1_ID:[],
    AUDIT_2_ID:[],
    AUDIT_3_ID:[],
    };
      let { year, plt_bld_id, time } = this.props

      this.getDataLayoutAll(year, plt_bld_id, time);
  }

    getDataLayoutAll(year, plt_bld_id, time){
        this.getDataLayout1(year ,plt_bld_id)
        this.getDataLayout2(year ,plt_bld_id)
        this.getDataLayout3Auto(year, plt_bld_id, time);
        this.getDataLayout4(year ,plt_bld_id)
    }

    getDataLayout1(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc07-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout1:'view',data1:data.data[0]});
                }
                console.log("getData1",data);
            }, err => {
            console.log("getData1", err);
        });
    }

    getDataLayout2(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc07-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout2:'view',data2:data.data[0]});
                }
                console.log("getData2",data);
            }, err => {
            console.log("getData2", err);
        });
    }

    getDataLayout3Auto(year, plt_bld_id, time) {
        let token = localStorage.getItem("ef_token");
        return fetch(
          Config.api +
            `/api/getReport-ef04dc07-l3-auto?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
          {
            headers: { "Content-Type": "application/json" }
          }
        )
          .then(response => response.json())
          .then(data => {
              this.getDataLayout3(year, plt_bld_id, time);
            }, err => {
              this.getDataLayout3(year, plt_bld_id, time);
            });
    }
    getDataLayout3(year, plt_bld_id, time){
        let token = localStorage.getItem("ef_token");
        return fetch(
          Config.api +
            `/api/getReport-ef04dc07-l3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
          {
            headers: { "Content-Type": "application/json" }
          }
        )
          .then(response => response.json())
          .then(data => {
              if (data.resultCode == 20000 && data.data) {
                this.setState({
                  modeLayout3: "view",
                  data3: data.data
                });
                setTimeout(() => {
                  let { listTable, data3 } = this.state;
                  listTable = listTable.map((r, i) => {
                    let d = {};
                    for (let j in data3) {
                      if (data3[j].STEP_C == i + 1 + "") {
                        d = data3[j];
                      }
                    }
                    d.UPDATE = false;
                    return { ...r, ...d };
                  });
                  this.setState({ listTable: listTable });
                }, 50);
              }
              console.log("getData3", data);
            }, err => {
              console.log("getData3", err);
            });
    }

    getDataLayout4(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc07-l4?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout4:'view',data4:data.data[0]});
                }
                console.log("getData4",data);
            }, err => {
            console.log("getData4", err);
        });
    }

getAUDIT_1_ID(){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getAUDIT_1_ID?token=${token}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({AUDIT_1_ID:data.data});
                }
                console.log("getAUDIT_1_ID",data);
            }, err => {
            console.log("getAUDIT_1_ID", err);
        });
    }

    getAUDIT_2_ID(){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getAUDIT_2_ID?token=${token}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({AUDIT_2_ID:data.data});
                }
                console.log("getAUDIT_2_ID",data);
            }, err => {
            console.log("getAUDIT_2_ID", err);
        });
    }

    getAUDIT_3_ID() {
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getAUDIT_3_ID?token=${token}`, {
            headers: { "Content-Type": "application/json", }
        }).then(response => response.json())
            .then(data => {
                if (data.resultCode == 20000 && data.data && data.data.length > 0) {
                    this.setState({ AUDIT_3_ID: data.data });
                }
                console.log("getAUDIT_3_ID", data);
            }, err => {
                console.log("getAUDIT_3_ID", err);
            });
    }

    putDataLayout2() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m1 } = this.state
        let data = { ...m1, token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc07-l2`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props
                    this.getDataLayout2(year, plt_bld_id)
                    this.setState({ visible2: false, m2: {} })
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    putDataLayout4() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m4 } = this.state
        let data = { ...m4, token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc07-l4`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props
                    this.getDataLayout4(year, plt_bld_id)
                    this.setState({ visible4: false, m2: {} })
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    insertUpdateDeleteDataLayout3($data) {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let data = { ...$data, token, step, plt_bld_id, year, time }
        return fetch(Config.api + `/api/postReport-ef04dc07-l3`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props
                    this.getDataLayout3(year, plt_bld_id)
                    if($data.update && $data.update.length > 0 || $data.insert && $data.insert.length > 0){
                        this.setState({ visible3: false, m3: {} })
                    }else{
                        
                    }
                    
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    Layout1(){
        let { data1,data2 } = this.state
        return <div>
            <h1>
              แบบกำหนดความรับผิดชอบในการตรวจสอบและรับรองการจัดการพลังงานตามข้อกำหนดวิธีการจดการพลังงานประจำปี{" "}
              {this.props.year}
            </h1>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <th style={{ width: "20%" }}>ชื่อโรงงานควบคุม</th>
                  <td style={{ width: "80%" }}>{data1.PLT_BLD_NAME}</td>
                </tr>
                <tr>
                  <th style={{ width: "20%" }}>รหัส TSIC-ID</th>
                  <td style={{ width: "80%" }}>{data1.TSIC_ID}</td>
                </tr>
                <tr>
                  <th style={{ width: "20%" }}>ชื่อนิติบุคคล</th>
                  <td style={{ width: "80%" }}>
                    {data1.JURISTIC_NAME}
                  </td>
                </tr>
                <tr>
                  <th style={{ width: "20%" }}>ที่ตั้งโรงงานควบคุม</th>
                  <td style={{ width: "80%" }}>{data1.ADDRESS_NAME}</td>
                </tr>
              </tbody>
            </table>
            <table style={{ borderSpacing: "1px 1px" }}>
              <tbody>
                <tr>
                  <th style={{ width: "20%" }}>
                    วันที่ตรวจสอบ ตั้งแต่วันที่
                  </th>
                  <td style={{ width: "30%", textAlign: "center" }}>
                    {tsDateToThaiDate(data2.START_D)}
                  </td>
                  <th style={{ width: "20%" }}>ถึงวันที่</th>
                  <td style={{ width: "30%", textAlign: "center" }}>
                            {tsDateToThaiDate(data2.END_D)}
                  </td>
                </tr>
                <tr>
                  <th style={{ width: "20%" }}>
                    ยืนยันการส่งผลการตรวจสอบทางอิเล็กทรอนิกส์แล้วเมื่อวันที่
                  </th>
                  <td colspan="4" style={{ width: "80%" }}>
                    {tsDateToThaiDate(data2.CONFIRM_D)}
                  </td>
                </tr>
              </tbody>
            </table>
            <span style={{ display: "block", textAlign: "right" }}>
              <ul className="myNavigation">
              <li>
                      <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                            this.setState({ visible2: true, m1: {...data2} });
                        }}>
                        <img src="images/iPencil.png" />
                        &nbsp;แก้ไข
                      </button>
                    </li>;
              </ul>
            </span>
          </div>;
    }

    Layout3(){
        let { data3 } = this.state
        return <div>
            <h1>การตรวจประเมิน</h1>
            <table style={{borderSpacing:'1px 1px'}}>
                <tbody>
                    <tr>
                        <th style={{textAlign:'center'}}>ลำดับ</th>
                        <th style={{width:'70%',textAlign:'center'}}>รายการตรวจประเมิน</th>
                        <th style={{width:'15%',textAlign:'center'}}>วันที่ตรวจสอบ</th>
                        <th style={{width:'15%',textAlign:'center'}}>ลงลายมือชื่อผู้ตรวจสอบแต่ละรายการ</th>
                    </tr>
                    {
                        data3.map((d,i)=>{
                        return <tr>
                                <td style={{textAlign:'center'}}>{i+1}</td>
                                <td>{d.STEP_DESC}</td>
                                <td style={{textAlign:'center'}}>{d.AUDIT_D}</td>
                                <td>&nbsp;</td>
                            </tr>
                        })
                    }

                </tbody>
            </table>
            <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                            onClick={() => { 
                            let { listTable } = this.state;
                            listTable = listTable.map((r,i)=>{
                                    let d = {}
                                    for(let j in data3){
                                        if(data3[j].STEP_C == (i+1)+""){
                                            d = data3[j];
                                        }
                                    }
                                    d.UPDATE = false;
                                    return {...r,...d}
                                })
                                this.setState({ visible3: true,listTable:listTable })}}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span>
        </div>
    }
    Layout4(){
         let { data4 } = this.state
         let SIGN_1_D = tsDateToThaiDate(data4.SIGN_1_D);
        return <div>
            <br/>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ขอรับรองว่าข้อความข้างต้นถูกต้อง เป็นจริงทุกประการ</div>
            <br/>
            <table className="MyStyle2">
                <tbody>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                        <td style={{width:'50%',textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>({data4.PERMIT_NAME})</td>
                        <td style={{width:'50%',textAlign:'center'}}>({data4.AUDIT_1})</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>{SIGN_1_D}</td>
                        <td style={{width:'50%',textAlign:'center'}}>{SIGN_1_D}</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>(ผู้รับใบอนญาต)</td>
                        <td style={{width:'50%',textAlign:'center'}}>(ผู้ชำนาญการ)</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>&nbsp;</td>
                        <td style={{width:'50%',textAlign:'center'}}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                        <td style={{width:'50%',textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>({data4.AUDIT_2})</td>
                        <td style={{width:'50%',textAlign:'center'}}>({data4.AUDIT_3})</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>{SIGN_1_D}</td>
                        <td style={{width:'50%',textAlign:'center'}}>{SIGN_1_D}</td>
                    </tr>
                    <tr>
                        <td style={{width:'50%',textAlign:'center'}}>(ผู้ช่วยผู้ชำนาญการ)</td>
                        <td style={{width:'50%',textAlign:'center'}}>(ผู้ช่วยชำนาญการ)</td>
                    </tr>
                    </tbody>
                </table>
                <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                              onClick={()=>{
                                  this.getAUDIT_1_ID();
                                  this.getAUDIT_2_ID();
                                  this.getAUDIT_3_ID();
                                  let {data4} = this.state
                                  this.setState({visible4:true,m4:{...data4}})
                                  }}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span>
            </div>
    }

    MDLayout2(){
        let { data1,data2 ,visible2,m1 } = this.state
        // console.log(m1);
        return <div>
            <Modal visible={visible2} title="บันทึกข้อมูลระยะเวลาการตรวจสอบ" onOk={() => {}} onCancel={() => {
                this.setState({ visible2: false, m1: {} });
              }} footer={[<Button key="back" onClick={() => {
                    this.setState({ visible2: false });
                  }}>
                  ปิด
                </Button>, <Button key="submit" type="primary" loading={false} onClick={() => {
                      this.putDataLayout2();
                }}>
                  บันทึกข้อมูล
                </Button>]}>
              <p>บันทึกข้อมูล</p>
              <div>
                <Datetimepicker name="START_D" value={m1.START_D} onSelect={(value) => {
                        let { m1 } = this.state;
                        m1.START_D = value
                        this.setState({ m1: m1})
                    }}/>
              </div>
              <p>ตรวจเสร็จวันที่</p>
              <div>
                <Datetimepicker name="END_D" value={m1.END_D} onSelect={(value) => {
                        let { m1 } = this.state;
                        m1.END_D = value;
                        this.setState({ m1: m1 })
                    }}/>
              </div>
            </Modal>
          </div>;
    }

    MDLayout3(){
        let { data1,data2,data3 ,visible3 ,listTable} = this.state
  
        // 
        return <div>
               <Modal
                visible={visible3}
                width={900}
                title="บันทึกข้อมูลความรับผิดชอบในการตรวจสอบ"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible3:false})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible3:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        let { listTable } = this.state;
                        let update = [],insert = [];
                        listTable.forEach((l,i)=>{
                            if(l.UPDATE){
                                if(l.STEP_C){
                                    //update
                                    update.push({STEP_C:l.STEP_C,AUDIT_D:l.AUDIT_D})
                                }else{
                                    // insert
                                    insert.push({STEP_C:(i+1),AUDIT_D:l.AUDIT_D})
                                }
                            }

                        })
                        if(update.length > 0 || insert.length > 0){
                            this.insertUpdateDeleteDataLayout3({update:update,insert:insert,delete:[]})
                            console.log(update,insert)
                        }else{
                            this.setState({visible3:false})
                        }
                       
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
               <table>
                <thead><tr>
                <th width="45">&nbsp;</th>
                <th>รหัสขั้นตอน</th>
                <th style={{textAlign:'center'}} width="200">วันที่ตรวจ</th>
                {/* <th style={{textAlign:'center'}} width="50">แก้ไข</th> */}
                <th style={{textAlign:'center'}} width="50">ลบ</th>
                </tr>
                </thead>
                <tbody>
                    {
                        listTable.map((d,i)=>{
                            return  <tr>
                                        <th style={{textAlign:'center'}}>{i+1}</th>
                                        <td >&nbsp;{d.text}&nbsp;</td>
                                        <td style={{textAlign:'center'}}>
                                         <Datetimepicker name={"AUDIT-D-"+i} value={d.AUDIT_D} onSelect={(value) => {
                                                // let { m1 } = this.state;
                                                // m1.START_D = value
                                                // this.setState({ m1: m1})
                                                listTable[i].AUDIT_D = value
                                                listTable[i].UPDATE = true

                                                this.setState({listTable:listTable})
                                            }}/>

                                        </td>
                                           
                                        <td style={{textAlign:'center'}}>
                                         { d.STEP_C?
                                            <a onClick={()=>{
                                                if(window.confirm("คุณต้องการลบ?")){
                                                    this.insertUpdateDeleteDataLayout3({update:[],insert:[],delete:[{STEP_C:d.STEP_C}]})
                                                }
                                                    
                                                }}><img width="18" height="18" src="images/iTrash.png"/></a>
                                            :null
                                            }
                                        </td>

                                    </tr>
                        })
                    }

                </tbody>
                </table>
                </Modal>
            </div>
    }

    MDLayout4(){
        let { data1, data2, data4, visible4, AUDIT_1_ID, AUDIT_2_ID, AUDIT_3_ID,m4 } = this.state
        return <div>
               <Modal
               
                visible={visible4}
                title="บันทึกข้อมูลผู้รับรองรายงาน"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible4:false})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible4:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                         this.putDataLayout4();
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
                <table>
				
                    {
                        m4 ?
                        <tbody>
                            <tr>
                            <td>ผู้ขอรับใบอนุญาต</td>
                            <td>
                                 <Select defaultValue="" style={{ width: 300 }} onChange={(value)=>{
                                    let { m4 } = this.state;
                                        m4.PERMIT_NAME_ID = value;
                                        this.setState({ m4: m4 })
                                        }} value={m4.PERMIT_NAME_ID} >
                                    <Option value="">----กรุณาเลือก----</Option>
                                    {
                                        AUDIT_3_ID.map((r)=>{
                                            return <Option value={r.PERSON_ID} selected="">{r.PERSON_NAME}</Option>
                                        })
                                    }
                                </Select>
                                {/* <input type="textbox" value={m4.PERMIT_NAME} size="40" maxlength="80"
                            onChange={(e)=>{
                                    let { m4 } = this.state;
                                    m4.PERMIT_NAME = e.target.value;
                                    this.setState({ m4: m4 })
                                }}
                            /> */}
                            </td>
                        </tr>
                        <tr>
                            <td>ผู้ชำนาญการ (ลงนาม)</td>
                            <td>
                                        <Select defaultValue="" style={{ width: 300 }} onChange={(value)=>{
                                    let { m4 } = this.state;
                                        m4.AUDIT_1_ID = value;
                                        this.setState({ m4: m4 })
                                }} value={m4.AUDIT_1_ID} >
                                    <Option value="">----กรุณาเลือก----</Option>
                                    {
                                        AUDIT_1_ID.map((r)=>{
                                            return <Option value={r.PERSON_ID} selected="">{r.PERSON_NAME}</Option>
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <td>ผู้ช่วยชำนาญการ 1 (ลงนาม)</td>
                            <td>
                                        <Select defaultValue="" style={{ width: 300 }} onChange={(value)=>{
                                    let { m4 } = this.state;
                                        m4.AUDIT_2_ID = value;
                                        this.setState({ m4: m4 })
                                }}  value={m4.AUDIT_2_ID}>
                                <Option value="">----กรุณาเลือก----</Option>
                                {
                                    AUDIT_2_ID.map((r)=>{
                                        return <Option value={r.PERSON_ID} selected="">{r.PERSON_NAME}</Option>
                                    })
                                }
                            </Select>
                            </td>
                        </tr>
                        <tr>
                            <td>ผู้ช่วยชำนาญการ 2 (ลงนาม)</td>
                            <td>
                                        <Select defaultValue="" style={{ width: 300 }} onChange={(value)=>{
                                    let { m4 } = this.state;
                                    console.log(value)
                                        m4.AUDIT_3_ID = value;
                                        this.setState({ m4: m4 })
                                }}  value={m4.AUDIT_3_ID}>
                                    <Option value="">----กรุณาเลือก----</Option>
                                {
                                    AUDIT_2_ID.map((r)=>{
                                        return <Option value={r.PERSON_ID} selected="">{r.PERSON_NAME}</Option>
                                    })
                                }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <td>วันที่ลงนามรับรอง</td>
                            <td>
                                <Datetimepicker name="SIGN_1_D_M4" value={m4.SIGN_1_D} onSelect={(value) => {
                                        let { m4 } = this.state;
                                        m4.SIGN_1_D = value;
                                        this.setState({ m4: m4 })
                                    }}/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="right">
                                &nbsp;
                            </td>
                        </tr>
                    </tbody>
                        :null
                    }
				</table>
            </Modal>
            </div>
    }

  render() {
     let {modeLayout1 ,modeLayout2 ,modeLayout3 ,modeLayout4 } = this.state

    return <div>
                <div className='myForm-2' style={{minHeight:'530px'}}>
                    {this.MDLayout2()}
                    {this.MDLayout3()}
                    {this.MDLayout4()}
                    {modeLayout1?this.Layout1():null}
                    {modeLayout3?this.Layout3():null}
                    {modeLayout4?this.Layout4():null}
                </div>
          </div>;
  }
}

export default Xpage6ef04dc07;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef04dc07.js